import React from 'react';

import * as am5 from '@amcharts/amcharts5';
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
//older applied logo
//import LogoImage from '../../../../../../public/img/circle_am_logo.png'
import LogoImage from '../../../../../../public/img/Circlelogoapplied-02-12-2025.png'


import ArctryxLogo from '../../../../../../public/img/alcTransparent.png'
import '../index.scss'
import { CHART_DATA, lineBreakSubCategories } from '../constants';
import { FEEDBACK_360_SURVEY } from '../../../../../../config/questionTypeConstants';

const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

function formatText(text, maxLength = 15) {
  let modified = text
  if (text.includes("\n")) {
    let splittedText = text.split('\n')
    if (splittedText[0].length > maxLength) {
      let newLine = splittedText[0].trim().split(/\s+/);
      if (newLine[0].length > maxLength) {
        splittedText[0] = splittedText[0] + splittedText[1].slice(0, maxLength) + "..."
        let returnValue = splittedText[0].slice(0, maxLength) + "..." + '\n' + "..." + splittedText[1].slice(maxLength - 5, maxLength)
        return returnValue
      }
      else {
        splittedText[0] = newLine[0]
        splittedText[1] = newLine[1] + splittedText[1]
      }
    }
    if (splittedText[1].length > maxLength) {
      modified = splittedText[0] + '\n' + splittedText[1].slice(0, maxLength) + "...";
    }
    return modified
  }
  else {
    if (text.length <= maxLength) {
      return text
    }
    else {
      if (text.includes('-')) {
        const hyphenIndex = text.indexOf("-");
        const firstLine = text.slice(0, hyphenIndex + 1);
        let secondLine = text.slice(hyphenIndex + 1);
        if (secondLine.length > maxLength) {
          secondLine = secondLine.slice(0, maxLength) + "...";
        }
        return `${firstLine}\n${secondLine}`;

      }
      else {
        if (text.trim().split(/\s+/).length >= 2) {
          let latestData = text.trim().split(/\s+/);
          if (latestData[0].length > maxLength) {
            latestData[0] = latestData[0].slice(0, maxLength) + "..." + '\n' + "..." + latestData[1].slice(maxLength - 5, maxLength)
          }
          else {
            latestData[1] = latestData[1].length > maxLength ? latestData[1].slice(0, maxLength) + "..." : latestData[1]
            return latestData[0] + '\n' + latestData[1]
          }


        }
      }

      modified = modified.slice(0, maxLength) + "...";
      return modified
    }
  }


}

export const RadarChart = (props) => {
    return (
      <BarChartV4Am5 {...props} />
   
      );
  };

  export class BarChartV4Am5 extends React.Component {


    componentDidMount = () => {
        this.startChart()
      };


      startChart = () => {
        const chartId = this.props.chartId || "chartdiv";
        // Dispose any amcharts root still attached to this DOM node before
        // creating a new one. Antd Tabs keeps inactive panes mounted, so on
        // tab switches a stale root can linger on the fixed chart id and amcharts
        // throws "You cannot have multiple Roots on the same DOM node".
        const targetEl =
          typeof document !== "undefined" ? document.getElementById(chartId) : null;
        if (am5.registry && am5.registry.rootElements) {
          am5.registry.rootElements
            .filter((existingRoot) => existingRoot && existingRoot.dom === targetEl)
            .forEach((existingRoot) => existingRoot.dispose());
        }
        let root = am5.Root.new(chartId);
        // Keep a handle so componentWillUnmount can dispose it (otherwise the
        // root leaks and a remount on the same id throws "id already in use").
        this.root = root;
        let chart = root.container.children.push(am5radar.RadarChart.new(root, {
            innerRadius: am5.percent(21)
        }));
    
        root._logo.dispose();
        let xRenderer = am5radar.AxisRendererCircular.new(root, {
          minGridDistance: 10
        });
        xRenderer.labels.template.setAll({
          text: "{subCategory}", // Original category label
          oversizedBehavior: "wrap",
          maxWidth: 80,
          // The config preview omits sub-category names (no real names yet).
          forceHidden: !!this.props.hideLabels,
          // Sub-category label font size — overridable via prop (used by the
          // PDF renderer to bump up labels because the chart gets visually
          // scaled down to fit the page).
          fontSize: this.props.subCategoryFontSize || 11,
          // fontWeight: "500",
          textAlign: "center",
          textType: "circular",
          lineHeight: 1.7,
          orientation: this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_APPLIED_MATERIALS_DIRECTORS || this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? "inward" : "auto"
        });

        xRenderer.grid.template.setAll({
          stroke: am5.color(0x000000), // Set stroke color to black
          strokeOpacity: 1 // Fully opaque stroke
        });

        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
          maxDeviation: 0,
          categoryField: "subCategory",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {})
        }));
        const isPdf = this.props.isForPdfGeneration;
        xAxis.get("renderer").labels.template.adapters.add("html", function (html, target) {
          let dataItem = target.dataItem && target.dataItem.dataContext.subCategory;
          if (dataItem) {
            if (dataItem === "Builds Trust & Camaredie") {
              dataItem = "Build Trust & Camaraderie"
            }
            target.dataItem.dataContext.subCategory = toTitleCase(dataItem);

            if (lineBreakSubCategories.includes(target.dataItem.dataContext.subCategory)) {
              let subCategory = target.dataItem.dataContext.subCategory;
              if (!subCategory.includes("\n")) {
                subCategory = subCategory.replace("Understand", "Understand\n");
                subCategory = subCategory.replace("Adopt enterprise-", "Adopt enterprise-\n");
                subCategory = subCategory.replace("Enable Team Learning", "Enable Team Learning\n");
                subCategory = subCategory.replace("Seek And Act", "Seek And Act\n");
                subCategory = subCategory.replace("Learn And Adapt To", "Learn And Adapt To\n");
                subCategory = subCategory.replace("Drive High Performance", "Drive High\n Perf")
                subCategory = subCategory.replace("Accept Responsibility", "Accept\n Responsibility")

            }
            target.dataItem.dataContext.subCategory = subCategory;

            }else if (!target.dataItem.dataContext.subCategory.includes("\n")){
              const modifiedText = dataItem.replace(/(\S+\s+\S+\s+)/, "$1\n");
              let finalText = !isPdf ? formatText(modifiedText,) : modifiedText

              target.dataItem.dataContext.subCategory = finalText;
            }
          }
      });

        let yRenderer = am5radar.AxisRendererRadial.new(root, {
          minGridDistance: 30,
          
        });

        yRenderer.grid.template.setAll({
          stroke: am5.color("#3B3B3B"), // Darker grey color for grid lines
          strokeOpacity: 1
        });

        yRenderer.labels.template.setAll({
          visible: true,
          // The config preview hides the 1-6 number labels but keeps the grid.
          forceHidden: !!this.props.hideLabels,
          // Radial-axis number font size (1-6 scale) — overridable via prop.
          fontSize: this.props.axisFontSize || 12,
        })

        yRenderer.labels.template.adapters.add("y", (y, target) => {
          return y - 3; // Adjust this value as needed to move the labels upwards
        });

        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
          renderer: yRenderer,
          max: 6,
          min: 1,
        }));
    
        let series1 = chart.series.push(
          am5radar.RadarColumnSeries.new(root, {
            name: "Series 4",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "subCategoryColumnScore",
            categoryXField: "subCategory",
            opacity: 0.8,
          })
        );
    
        let series = chart.series.push(am5radar.RadarLineSeries.new(root, {
          name: "Series",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "selfAverageScore",
          categoryXField: "subCategory",
          stroke: am5.color("#000000"),
          connect: false
        }));
    
        let series6 = chart.series.push(am5radar.RadarLineSeries.new(root, {
            name: "Series3",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "benchmarkScore",
            categoryXField: "subCategory",
          stroke: am5.color("#000000"),      
          }));
    
        // An explicit palette can be passed in (e.g. by the Circumplex config
        // preview, where sub-category colours are auto-generated tints of the
        // user-chosen pillar colours). Falls back to the built-in palettes.
        const colorPalette = this.props.colorPalette ? this.props.colorPalette :
          this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? [
          "#0099FF", "#0086FB", "#0071CE", "#0061B4", "#034F95",
          "#E7E9E9", "#DCDDDE", "#CBCBCB", "#BCBDBD",
          "#8CCCFF", "#81BBEF", "#74A9D9", "#5D87AE",
          "#B1B1B1", "#797979", "#5B5B5B", "#4F4F4F",



        ] : [
          "rgba(253, 207, 142)", "rgba(252, 188, 96)", "rgba(252, 177, 64)",
          "rgb(180, 203, 228)", "rgb(105, 151, 201)", "rgba(83,136,193)",
          "rgba(216, 166, 204)", "rgba(200, 132, 186)", "rgba(190, 107,171)",
          "rgba(143, 212, 173)", "rgba(93, 196, 141)", "rgba(0, 161, 75)",
          "rgba(151, 210, 239)", "rgba(90, 186, 231)", "rgba(36, 170, 225)",
        ];


        // Keep palette + series on the instance so the colours can be updated
        // in place (see recolor) without rebuilding the whole chart.
        this.activePalette = colorPalette;
        this.columnSeries = series1;
        // Only the config preview (which supplies its own palette) uses the
        // recolour-in-place path; production keeps the original fill logic
        // exactly as-is to avoid any change to existing circumplex/PDF colours.
        const usesCustomPalette = !!this.props.colorPalette;

        series1.columns.template.adapters.add("fill", (fill, target) => {
          const palette = this.activePalette;
          if (!usesCustomPalette) {
            // Original production behaviour, unchanged.
            return palette[series1.columns.indexOf(target) % palette.length];
          }
          // Preview path: prefer the stable data-item index; fall back to the
          // column index. (columns.indexOf can return -1 before the column list
          // settles, yielding an undefined colour / amcharts default grey.)
          let index = target.dataItem ? series1.dataItems.indexOf(target.dataItem) : -1;
          if (index < 0) {
            index = series1.columns.indexOf(target);
          }
          if (index < 0) {
            return fill;
          }
          return palette[index % palette.length];
        });
    
        series1.columns.template.setAll({
          strokeOpacity: 0,
          width: am5.percent(100),
          stacked: true,


        });
    
    
        // series.strokes.template.setAll({
        //   strokeWidth: 1.5,
        //   strokeDasharray: [10, 5]
        // });


        series6.strokes.template.setAll({
          strokeWidth: 1.5,
          strokeDasharray: [10, 5]
        });


        series.data.setAll(this.props.radarChartData);
        xAxis.data.setAll(this.props.radarChartData);
        series1.data.setAll(this.props.radarChartData);
        if (this.props.projectType !== FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX) {
          series6.data.setAll(this.props.radarChartData)

        }
    
    
    
        // Animate chart and series in
        // https://www.amcharts.com/docs/v5/concepts/animations/#Initial_animation
        // For PDF generation, render instantly (no appear animation) so the
        // chart is paint-ready immediately and Puppeteer doesn't wait it out.
        const appearDuration = isPdf ? 0 : 1000;
        series.appear(appearDuration);
        chart.appear(appearDuration, isPdf ? 0 : 100);
      }    

    // Recolour the existing columns in place from a new palette, without
    // tearing down and rebuilding the chart (avoids the flicker you get when
    // the component is remounted on every colour change).
    recolor = (palette) => {
      if (!palette || !this.columnSeries) {
        return;
      }
      this.activePalette = palette;
      const series1 = this.columnSeries;
      series1.columns.each((column) => {
        let index = column.dataItem ? series1.dataItems.indexOf(column.dataItem) : -1;
        if (index < 0) {
          index = series1.columns.indexOf(column);
        }
        if (index < 0) {
          return;
        }
        // Set the fill; the fill adapter (which now reads the updated
        // activePalette) re-runs and the new colour sticks.
        column.set("fill", am5.color(palette[index % palette.length]));
      });
    };

      componentWillUnmount() {
        if (this.root) {
          this.root.dispose();
        }
      }

      componentDidUpdate(prevProps, prevState) {
        // A logo-only change just re-renders the DOM overlay; the amcharts
        // chart (built in componentDidMount) must be left untouched.
        const onlyLogoChanged =
          prevProps.logoUrl !== this.props.logoUrl ||
          prevProps.logoPlaceholder !== this.props.logoPlaceholder ||
          prevProps.hideLogo !== this.props.hideLogo;
        if (onlyLogoChanged) {
          return;
        }
        // Otherwise (chart data changed) rebuild the chart. Dispose the existing
        // root first — without this the old root stays attached and amcharts
        // throws "multiple Roots on the same DOM node" on the next create.
        // (Disposing this.root, not this.chart, which is never assigned.)
        if (this.root) {
          this.root.dispose();
          this.root = null;
        }
        this.startChart();
      }

      shouldComponentUpdate = (nextProps) => {
        // Re-render when the chart data changes, or when only the centre logo
        // changes (the logo is plain DOM and does not rebuild the chart).
        return (
          nextProps.config !== this.props.config ||
          nextProps.data !== this.props.data ||
          nextProps.logoUrl !== this.props.logoUrl ||
          nextProps.logoPlaceholder !== this.props.logoPlaceholder ||
          nextProps.hideLogo !== this.props.hideLogo
        );
      };


    

      render() {
        return (
              <div className='graph-container'>

            <div className='radar-chart' id={this.props.chartId || "chartdiv"} ></div>
            {/* Centre logo:
                - logoUrl (e.g. the Circumplex config upload) is shown, fitted
                  into the centre hole;
                - else, when logoPlaceholder is requested, a "LOGO" placeholder;
                - else the baked-in project logo (unless hideLogo). */}
            {this.props.logoUrl && this.props.projectType === FEEDBACK_360_SURVEY.MODULAR_360_FEEDBACK ?
              <img className={`logo-image logo-image--custom${this.props.responsiveLogo ? ' logo-image--responsive' : ''}`} style={this.props.responsiveLogo ? undefined : { width: this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? "88px" : "108px", height: this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? "88px" : "108px", top: this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? "313px" : undefined }} src={this.props.logoUrl} alt="Logo" />
              : this.props.projectType === FEEDBACK_360_SURVEY.MODULAR_360_FEEDBACK ?
                // Modular 360 only shows an uploaded logoUrl; with none, show nothing.
                null
              : this.props.logoPlaceholder ?
                <div className={`logo-image logo-image--placeholder${this.props.responsiveLogo ? ' logo-image--responsive' : ''}`}>LOGO</div>
                : !this.props.hideLogo &&
                <img className='logo-image' style={{ width: this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? "88px" : "108px", top: this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? "313px" : undefined }} src={this.props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? ArctryxLogo : LogoImage} alt="Logo" />
            }

          </div>
        );
      }
  }